import {connect, Dispatch} from '@modifi/redux'
import {aShowDialog, DialogManager} from '@modifi/plugin-dialogs'

import DeleteIntermediaryShareHolderButton from './DeleteIntermediaryShareHolderButton'
import {aDelete} from './store'
import DeleteShareholder, {DELETE_SHAREHOLDER_DIALOG_NAME} from './dialogs'

DialogManager.addDialog(DELETE_SHAREHOLDER_DIALOG_NAME, DeleteShareholder)

const mapStateToProps = null

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: {externalShareholderCompanyId: string; target: string}
): {onClick: () => void} => ({
  onClick: (): void => {
    const onConfirm = async (): Promise<void> => {
      await dispatch(aDelete(ownProps.externalShareholderCompanyId) as any)
    }

    dispatch(
      aShowDialog(DELETE_SHAREHOLDER_DIALOG_NAME, {
        onConfirm,
        target: ownProps.target,
        entryType: 'confirm-delete-intermediary-shareholder',
      })
    )
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteIntermediaryShareHolderButton)
